import React, { useEffect } from "react";
import AllRoute from "./route/route";
import PrivateRoute from "./route/PrivateRoute";
import { useSelector, useDispatch } from "react-redux";
import { loadInitialData } from "./actions/auth-action";

const Main = () => {
  const theme =  useSelector((state) => state.settings.selected_theme) || 'light';
  document.body.className = theme;
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.user);
  const gaConfirmed = useSelector((state) => state.auth.gaConfirmed);
  const gaEnabled = useSelector((state) => state.settings.gaEnabled);
  const initialDataLoaded = useSelector((state) => state.auth.initialDataLoaded);

  useEffect(() => {
    if (token && user && (gaConfirmed || !gaEnabled) && !initialDataLoaded) {
        dispatch(loadInitialData(user));
    }
  }, [token, user, gaConfirmed, gaEnabled, initialDataLoaded, dispatch]);

  const RouteComponent = AllRoute.map((route, i) => (
    <PrivateRoute
      key={i}
      exact={route.exact}
      path={route.path}
      component={route.component}
    />
  ));
  return (
    <div>
      {RouteComponent}
    </div>
  );
};

export default Main;
